import { Badge } from '@src/design-system/badge';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import parse from 'html-react-parser';
import { Edit2 } from 'iconsax-react';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { CreateOrEditReminderTemplate } from '@src/shared/features/reminders/dialogs/create-or-edit-reminder-template';

import { getStatusBadgeVariant } from '../../../shared/features/reminders/helpers/get-status-badge-variant';
import { getChannelSvg } from '../../../shared/features/reminders/helpers/get-channel-svg';
import { DeleteReminderTemplateButton } from './delete-reminder-template-button';
import { SyncReminderTemplateButton } from './sync-reminder-template-button';
import { REMINDER_CHANNELS } from '@src/shared/types/reminder';

import type { TReminderTemplate } from '@src/shared/types/reminder-template';

export const ReminderTemplateCard = (reminderTemplate: TReminderTemplate) => {
  const { id, name, content, channel = 'EMAIL', status } = reminderTemplate;
  const isEmailTemplate = channel === REMINDER_CHANNELS.email;
  const isSyncChannel =
    channel === REMINDER_CHANNELS.sms || channel === REMINDER_CHANNELS.whatsapp;

  return (
    <div className='flex flex-col h-full cursor-pointer border hover:border-primary-500 transition-all duration-300 border-primary-200 items-start rounded-2xl gap-2 bg-[#FDFDFE] p-4'>
      <div className='flex self-stretch mb-4 items-start justify-between'>
        <img
          className='w-6! h-6!'
          src={getChannelSvg(channel)}
          alt={name}
        />
        <div className='flex items-center'>
          {isSyncChannel ? (
            <Badge
              variant={getStatusBadgeVariant(status)}
              className='py-1.5 px-2 rounded-[8px] me-2'
            >
              {formatTextForDisplay(status)}
            </Badge>
          ) : null}

          {isEmailTemplate ? (
            <Dialog>
              <DialogTrigger
                asChild
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type='button'
                  className='size-8 cursor-pointer rounded-lg flex items-center justify-center hover:bg-primary-100'
                  aria-label='Edit reminder template'
                >
                  <Edit2 size={18} />
                </button>
              </DialogTrigger>
              <DialogContent
                onOpenAutoFocus={(e) => e.preventDefault()}
                onClick={(e) => e.stopPropagation()}
                className='flex w-full max-w-[78%] flex-col overflow-hidden'
              >
                <CreateOrEditReminderTemplate
                  reminderTemplate={reminderTemplate}
                />
              </DialogContent>
            </Dialog>
          ) : null}

          <DeleteReminderTemplateButton
            id={id}
            name={name}
          />

          <SyncReminderTemplateButton
            id={id}
            channel={channel}
            status={status}
          />
        </div>
      </div>

      <h5 className='font-medium!'>{name}</h5>

      <div className='text-start text-sm text-gray-800 break-all line-clamp-2'>
        {parse(content || '')}
      </div>
    </div>
  );
};
